import React, { Component } from "react";

class ErrorModal extends Component {
  render() {
    return (
      <div className="modal modal--full fade show scroller-block">
        <div className="modal__content modal-dialog pr">
          <div className="table">
            <div className="table-cell">
              <div className="modal__inner pr">
                <h3 className="modal__title monserrat-medium fs32 tc">
                  {this.props.title}
                </h3>

                <p className="modal__description fs13 tc mb-none">
                  {this.props.description}{" "}
                  <span
                    className="modal__action-text"
                    onClick={() => window.location.reload()}
                  >
                    {this.props.action_text}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorModal;
